import React, { useEffect, useState } from "react";

interface IProps {
  collection: any;
}

const CollectionCart: React.FC<IProps> = ({ collection }) => {
  const [bgImage, setBgImage] = useState(
    window.innerWidth < 1024 ? collection?.res_image : collection?.image
  );

  useEffect(() => {
    const handleResize = () => {
      setBgImage(
        window.innerWidth < 1024 ? collection?.res_image : collection?.image
      );
    };
    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [collection]);

  return (
    // <div className="relative bg-white w-full min-w-[240px] lg:w-[270px] h-[350px] sm:h-[400px] lg:h-[312px] rounded-[10px] flex flex-col items-center gap-y-3 border-2 border-yellow-color group ">
    //   <div className="flex flex-col w-full h-full justify-between">
    //     <div className="flex items-center rounded-lg overflow-hidden h-full sm:h-5/5 w-full ">
    //       {/* Image Section */}
    //       <div className="h-full  w-[350px]">
    //         <img
    //           src={collection?.image}
    //           alt={collection?.title || "Collection Image"}
    //           className={` h-full absolute  object-cover ${'/src/assets/images/coll2.png' == collection?.image ? 'w-[220px] lg:!h-[250px] ' : '/src/assets/images/coll4.png' == collection?.image ? 'w-[135px] lg:!h-[310px] rounded-bl-lg rounded-tl-lg' : 'w-[120px] lg:!h-[280px]'}`}
    //         />
    //       </div>
    //       {collection?.image2 && (
    //         <div className=" absolute right-0 -bottom-8 z-50">
    //           <img
    //             src={collection?.image2}
    //             alt="image2"
    //             className=" !h-[220px]"
    //           />
    //         </div>
    //       )}

    //       {/* Title Section */}
    //       <div className="flex-1 p-1 w-full ">
    //         <p className="w-full text-lg font-semibold flex flex-col gap-y-0  -mt-[104px] ">
    //           {words.map((word: any, index: any) => {
    //             return (
    //               <span
    //               key={index}
    //               style={{
    //                 color:
    //                   collection.colors[index % collection?.colors?.length],
    //                 textShadow: "2px 2px 6px rgba(0, 0, 0, 0.1)",
    //               }}
    //               className={`font-[900] text-[20px] md:text-[30px]  lg:mr-1 font-rubik -mt-1  ${'/src/assets/images/coll1.png' == collection?.image || '/src/assets/images/coll3.png' == collection?.image ? 'lg:text-[22px]' : 'lg:text-[18px]' }`}
    //             >
    //               {word}
    //             </span>
    //             )
    //           })}
    //         </p>
    //       </div>
    //     </div>

    //     {/* Description Section */}
    //     <div className={` text-center md:text-start  px-2 py-1 h-[130px] flex items-center justify-center -mb-4 ${collection?.image2 ?  'w-[70%]' : '/src/assets/images/coll4.png' == collection?.image ? ' w-1/2 text-end ml-auto bottom-4 relative' : 'w-full'}`}>
    //       <p className="text-[10px] font-normal font-rubik">
    //         {collection?.description}
    //       </p>
    //     </div>
    //   </div>

    //   {/* Icon Section */}
    //     {/* <div className="absolute bottom-0 right-0 hidden lg:flex">
    //       <img src={collIc} alt=".." className="w-[70px] h-[70px]" />
    //     </div> */}
    // </div>

    <div
      className="relative bg-no-repeat bg-contain bg-white min-w-[-440px]  w-[500px]  lg:w-[270px] h-[220px] sm:h-[312px] flex flex-col items-center gap-y-3  group mx-auto left-0 right-0"
      style={{
        backgroundImage: `url(${bgImage || "https://via.placeholder.com/400"})`,
      }}
    >
      {/* Title Section */}
      <div
        className={`p-1 w-full lg:w-[270px] absolute  left-0 right-0 ${collection?.title === 'Visko Yastık Koleksiyonu' ? 'bottom-[30px]  sm:bottom-10  lg:bottom-60' : 'bottom-[30px]  sm:bottom-10  lg:bottom-8'}`}
      >
        {/* <p className="w-full text-lg font-semibold flex flex-col gap-y-0  -mt-[104px] ">
          {words.map((word: any, index: any) => {
            return (
              <span
                key={index}
                style={{
                  color: collection.colors[index % collection?.colors?.length],
                  textShadow: "2px 2px 6px rgba(0, 0, 0, 0.1)",
                }}
                className={`font-[900] text-[20px] md:text-[30px]  lg:mr-1 font-rubik -mt-1  ${
                  "/src/assets/images/coll1.png" == collection?.image ||
                  "/src/assets/images/coll3.png" == collection?.image
                    ? "lg:text-[22px]"
                    : "lg:text-[18px]"
                }`}
              >
                {word}
              </span>
            );
          })}
        </p> */}
        {/* <p
          style={{
            textShadow: "2px 2px 4px rgba(0, 0, 0, 0.7)",
          }}
          className={`text-white flex justify-center items-center font-extrabold font-oswald text-[18px] ${collection?.title === 'Varis Çorap Koleksiyonu' ? 'pb-1' : ''}`}
        >
          {collection?.title}
        </p> */}
      </div>
    </div>
  );
};

export default CollectionCart;
